import AnimatedSection from './AnimatedSection';
import { getData } from '../utils/html';
import { $document } from '../utils/environment';
import { EVENT as SCROLL_EVENT } from '../scroll/Scroll';

export default class extends AnimatedSection {
    constructor(m) {
        super(m);

        this.zone = this.$('zone')
        this.mask = this.$('mask')
        this.inner = this.$('inner')
        this.bg = this.$('bg')

        this.triggerUi = getData(this.getData('triggerui'))
    }

    initTl() {
        let progress = 0
        if(this.scrollTl) {
            progress = this.scrollTl.progress()
            this.scrollTl.kill()
        }

        let object = {
            scale: this.scaleFrom
        }

        let ui = 'dark'
        this.scrollTl = new TimelineMax({ onUpdate: () => {
            TweenMax.set(this.mask, { scale: object.scale, force3D: true })
            TweenMax.set(this.inner, { scale: 1/object.scale, force3D: true })

            if(this.triggerUi) {
                if(ui == 'dark' && this.scrollTl.progress() >= 0.8) {
                    $document.trigger({
                        type: SCROLL_EVENT.TRIGGER_UI_LIGHT,
                        options: {}
                    });
                    ui = 'light'
                } else if(ui == 'light' && this.scrollTl.progress() < 0.8) {
                    $document.trigger({
                        type: SCROLL_EVENT.TRIGGER_UI_DARK,
                        options: {}
                    });
                    ui = 'dark'
                }
            }
        }})
        this.scrollTl.fromTo(object, 1, { scale: this.scaleFrom }, { scale: this.scaleTo, ease: Linear.easeNone }, 0)
        this.scrollTl.fromTo(this.bg, 1, { y: '-100%' }, { y: '0%', force3D: true, ease: Linear.easeNone }, 0)

        this.scrollTl.pause()
        this.scrollTl.progress(0)
    }

    compute() {
        this.viewport = {
            w: window.innerWidth,
            h: window.innerHeight
        }

        this.hasSmoothScroll = false
        if(document.documentElement.classList.contains('has-smooth-scroll'))
            this.hasSmoothScroll = true

        TweenMax.set([this.mask, this.inner], { clearProps: 'all' })

        // SCROLL RELATED
        this.BCR = this.zone.getBoundingClientRect()
        let compensation = this.hasSmoothScroll ? window.app.scroll.y : (document.scrollingElement ? document.scrollingElement.scrollTop : document.documentElement.scrollTop)
        this.offsetTop = this.BCR.top + compensation;
        this.scrollStart = this.offsetTop - window.innerHeight;
        this.scrollEnd = this.scrollStart + this.BCR.height
        this.scrollDiff = this.scrollEnd - this.scrollStart

        this.scaleFrom = window.innerWidth > window.innerHeight ? window.innerHeight/window.innerWidth : window.innerWidth/window.innerHeight
        this.scaleTo = Math.sqrt(Math.pow(this.viewport.w, 2) + Math.pow(this.viewport.h, 2)) / this.viewport.w
    }
}
